import { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import FirebaseFileSaver from '../services/firebase-filesaver';

import WebbLoader from './webb-loader';

import { GetAuthUser } from "../services/user-accounts";
import { GetTeamDocsDetail, SetTeamDocsStatus } from "../services/user-vault";

const stat = [
  {code:"Pending", colr:"warning"},
  {code:"Active", colr:"success"},
  {code:"Expired", colr:"danger"},
  {code:"Inactive", colr:"lite"},
]
export default function TeamCredsEditModule() {

  const asset = GetAuthUser();
  const { id } = useParams();
  const history = useHistory();

  const [loading,setLoading]=useState(false);
  const [text, setText] = useState('');
  const [form, setForm] = useState(false);

  const [data, setData] = useState({})

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setLoading(true);

        setData( (await GetTeamDocsDetail(JSON.stringify({
          body: {crid: id, usid: asset.usid, form: asset.form},
          user: {usid: asset.usid, form: asset.form}
        }))).data)

        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);

  // form validation
  useEffect( () => {
    setForm(false)
    if (data.file !=='' && data.nmbr !== '') 
      setForm(true);
  },[data]);

  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const SetFileLink = async(file) => {
    // console.log (file);
    handleChange("file", file);
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    console.log ({...data, stat: parseInt(data.stat), blck: data.blck})
    const response = await SetTeamDocsStatus (JSON.stringify({
      body: { 
        crid: id, stat: parseInt(data.stat),
        ents: data.stat === 3 ? data.ents ? data.ents : new Date() : null,
        blck: data.blck,
        srvc: asset.usid
      },
      user: { usid: asset.usid, form: asset.form }
    }))
    console.log (response)
    history.push ('/bz/team')
    setLoading(false);
  }

  if (loading){
    return ( <> <WebbLoader />  </> )
  }

  return (
    <>
      <p className="lead text-primary fw-bold m-0 p-0">{data.name}</p>
      <p className="lead fw-bold m-0 p-0">{data.user}</p>
      <p className="lead m-0 p-0">{data.nmbr}</p>
      <p className="small m-0 p-0">ID: {data.enid}</p>
      <p className="small mb-3">
        <span>{'Start: '}{data.stts}</span>
        <span>{' / '}</span>
        <span>{'End: '}{data.ents}</span>
      </p>


      <form onSubmit={handleSubmit}>

        <div className="mb-3">
          <label className="form-label small">Doc Image <span className="text-danger">*</span></label>
          <FirebaseFileSaver name={'sender'} avtr={data.file} link = {SetFileLink}/>    
        </div>

        <div className="mb-3">
          <label className="form-label small">Status <span className="text-danger">*</span></label>
          <select 
            className="form-select height-md"
            value={data.stat}
            onChange={({ target }) => { handleChange("stat", target.value) }}>
            <option value=''>Select Status</option>
            {stat.map((item,i) => (
              <option key={i} value={i}>{item.code}</option>
            ))}
          </select>
        </div>

        <div className={`mb-3`}>
          <div className="form-group">
            <label className="form-label small">End Date <span className="text-danger">*</span></label>
            <input type="date" className="form-control height-md"
              value={data.ents}
              onChange={({ target }) => {handleChange("ents", target.value); setText('');}}
              placeholder="">
            </input>
          </div>
        </div> 


        <div className='rounded bg-white border px-3 mb-3'>
          <div className="form-check form-switch p-0">
            <div className="d-flex py-2">
            <div className="me-auto">
                <p className="m-0 p-0">{'Blacklist'}</p>
              </div>
              <div className="ps-3">
                <input  className="form-check-input" 
                  type="checkbox"
                  style={{fontSize:"1.1em"}}
                  checked={data.blck}
                  onChange={({ target }) => handleChange("blck", target.checked)}
                  >
                </input>
              </div> 
            </div>
          </div>
        </div>

        <div className="">
          <div className="d-grid">
            <button className={`btn height-md ${ form ? 'btn-primary' : 'btn-light'}`}
              disabled={!form}
            ><small>Save & Continue</small>
            </button>
          </div>
        </div>

        </form>
    </>
  )
}